async function asJson(res) {
    if (!res.ok) {
        let msg = res.statusText;
        try {
            const body = (await res.json());
            if (body?.error)
                msg = body.error;
        }
        catch {
            /* ignore */
        }
        throw new Error(msg || `HTTP ${res.status}`);
    }
    return (await res.json());
}
function postJson(url, body) {
    return fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
    });
}
export async function getStatus() {
    return asJson(await fetch("/api/poll/status"));
}
export async function assign(refData) {
    return asJson(await fetch("/api/poll/assign", {
        method: "POST",
        headers: refData ? { "Content-Type": "application/json" } : {},
        body: refData ? JSON.stringify(refData) : undefined,
    }));
}
/** Per-stage save. Send only the field(s) the user just locked in. */
export async function answer(body) {
    return asJson(await postJson("/api/poll/answer", body));
}
export async function submit(body) {
    return asJson(await postJson("/api/poll/submit", body));
}
export async function verifyEmail(body) {
    return asJson(await postJson("/api/poll/verify-email", body));
}
export async function adminLogin(password) {
    return asJson(await postJson("/api/admin/login", { password }));
}
export async function adminLogout() {
    return asJson(await fetch("/api/admin/logout", { method: "POST" }));
}
export async function adminSession() {
    return asJson(await fetch("/api/admin/session"));
}
export async function adminResults() {
    return asJson(await fetch("/api/admin/results"));
}
export async function adminEndPoll() {
    return asJson(await fetch("/api/admin/end-poll", { method: "POST" }));
}
export async function adminReopenPoll() {
    return asJson(await fetch("/api/admin/reopen-poll", { method: "POST" }));
}
export async function adminSetClose(closesAt) {
    return asJson(await postJson("/api/admin/set-close", { closesAt }));
}
export async function getPublicResults() {
    return asJson(await fetch("/api/poll/results"));
}
export async function adminPublishResults() {
    return asJson(await fetch("/api/admin/publish-results", { method: "POST" }));
}
export async function subscribe(body) {
    return asJson(await postJson("/api/poll/subscribe", body));
}
export async function sendPreviewLink(body) {
    return asJson(await postJson("/api/poll/preview-link", body));
}
/**
 * Fetch the public case-study payload (no auth, 30s edge-cached).
 *
 * Returns a discriminated union so the page can render a "take the survey
 * first" gate when the API gates the response on cookie state. The data
 * endpoint returns 403 if the requester has no respondent cookie; we map
 * that specific status to `{ status: 'gated' }`. Any other failure throws
 * via asJson, surfacing as an error in the page UI.
 */
export async function getCaseStudyData() {
    const res = await fetch("/api/case-study/data");
    if (res.status === 403)
        return { status: "gated" };
    const data = await asJson(res);
    return { status: "ok", data };
}
